<template>
    <section class="map-cover h-100 w-100">
        <gmap-map class="gmap h-100 w-100"
                  v-bind:center="mapCenter"
                  v-bind:zoom="mapZoom"
                  v-bind:map-type-id="defaultMapType"
                  v-bind:options="mapOptions"
                  v-on:zoom_changed="zoomChanged">
            <!-- <gmap-cluster zoom-on-click>
                <gmap-marker clickable
                             v-for="marker in markers"
                             v-bind:key="marker._id"
                             v-bind:position="marker.coordinate"
                             v-bind:animation="2"
                             v-bind:icon="{ url: `${ $config.apiUrl }/${ $config.apiVersion }/shop/category/icon/${ marker.category.icon }`, scaledSize: iconSize }"
                             v-on:click="markerClicked(marker)">
                </gmap-marker>
            </gmap-cluster> -->
        </gmap-map>
        <div class="filter position-absolute h-100 w-100"
             v-bind:class="{ 'allow-click-through': allowClickThrough }">
        </div>
    </section>
</template>

<script>
    import {
        gmapApi
    } from "vue2-google-maps"
    import GoogleMapCluster from "vue2-google-maps/dist/components/cluster"

    export default {
        name: "MapCover",
        components: {
            "GmapCluster": GoogleMapCluster
        },
        props: {
            "mapType": {
                type: String,
                default: "terrain"
            },

            "markers": {
                type: Array,
                default: () => []
            },

            "allowClickThrough": {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                defaultMapCenter: {
                    lat: 22.331759,
                    lng: 114.088233,
                },
                defaultMapZoom: 12,
                defaultMapZoomSmall: 10.5,
                defaultMapType: "roadmap",
                defaultIconSize: {
                    width: 40,
                    height: 40
                },

                customMapZoom: null,

                windowInnerWidth: window.innerWidth,
            }
        },
        computed: {
            google: gmapApi,

            mapCenter () {
                if (this.locationSelected) {
                    return this.locationSelected.position;
                }
                return this.defaultMapCenter;
            },

            mapZoom () {
                if (this.locationSelected) {
                    return 17;
                }
                return this.windowInnerWidth >= 992 ? this.defaultMapZoom : this.defaultMapZoomSmall;
            },

            zoomControlPosition () {
                return this.windowInnerWidth >= 992 ? 7 : 9;
            },

            mapTypeControlPosition () {
                return this.windowInnerWidth >= 992 ? 9 : 11;
            },

            mapOptions () {
                return {
                    "zoomControl": false,
                    "zoomControlOptions": {
                        "position": this.zoomControlPosition,
                    },
                    "mapTypeControl": false,
                    "mapTypeControlOptions": {
                        "position": this.mapTypeControlPosition,
                    },
                    "scaleControl": false,
                    "streetViewControl": false,
                    "rotateControl": false,
                    "fullscreenControl": false,
                    "disableDefaultUi": true,
                };
            },

            iconBaseSize () {
                return {
                    width: this.defaultIconSize.width / this.defaultMapZoom,
                    height: this.defaultIconSize.height / this.defaultMapZoom
                }
            },

            iconSize () {
                return this.customMapZoom
                    ? {
                        width: this.customMapZoom <= 12 ? this.iconBaseSize.width * this.customMapZoom : this.iconBaseSize.width * this.customMapZoom * (1 - Math.pow(0.05, this.customMapZoom - 12)),
                        height: this.customMapZoom <= 12 ? this.iconBaseSize.height * this.customMapZoom : this.iconBaseSize.height * this.customMapZoom * (1 - Math.pow(0.05, this.customMapZoom - 12))
                    }
                    : this.defaultIconSize
            }
        },
        methods: {
            zoomChanged (zoom) {
                this.customMapZoom = zoom
            },

            markerClicked (property) {
                this.$router.push({
                    name: this.$route.name.includes("-city") ? "property-city" : "property",
                    params: {
                        id: property._id
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .map-cover {
        & > .filter {
            box-shadow: inset 0 0 5rem rgba(0, 0, 0, 0.5);
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;

            &.allow-click-through {
                pointer-events: none;
            }
        }
    }
</style>
